import type { NskResponse } from "~/models/Api";
import type { SurveyAnswer } from "~/models/Survey";
import { putRequest } from "~/utils/api/api_handler";

const paths = {
	update: "/deal_statuses/:deal_id"
};

export const update = async (
	dealId: number,
	statusId: number,
	reason: string | null,
	surveyAnswers: SurveyAnswer[] | null
): Promise<NskResponse> =>
	putRequest(paths.update.replace(":deal_id", String(dealId)), {
		reason,
		statusId,
		surveyAnswers
	});
